module.exports = __webpack_public_path__ + "img/icon_language_setting_selected.6d8edf4d.svg";